import axios from 'axios'
const BASE_API_URL = process.env.REACT_APP_API_URL
//=====================Country URL======================
const GET_MemberReport_AllList = `${BASE_API_URL}/MemberReport/GetRamNamMemberReportList` //Get Country Page
const GET_MemberLiveReport_AllList = `${BASE_API_URL}/Member/GetLiveJaapMemberList` //Get Country Page

// =========GET COUNTRY=================================
export function getMemberReportListApi(
  search: string,
  memberTypeID: number,
  pageNumber: number,
  pageSize: number,
  sortColumn: string,
  sortDirection: string
) {
  return axios.post(GET_MemberReport_AllList, {
    search,
    memberTypeID,
    pageNumber,
    pageSize,
    sortColumn,
    sortDirection,
  })
}
// =========GET COUNTRY=================================
export function getMemberLiveReportListApi(
  search: string,
  pageNumber: number,
  pageSize: number,
  sortColumn: string,
  sortDirection: string
) {
  return axios.post(GET_MemberLiveReport_AllList, {
    search,
    pageNumber,
    pageSize,
    sortColumn,
    sortDirection,
  })
}
